import { render, staticRenderFns } from "./FinanceStudentPlacementAddEdit.vue?vue&type=template&id=4138ab1b"
import script from "./FinanceStudentPlacementAddEdit.vue?vue&type=script&lang=js"
export * from "./FinanceStudentPlacementAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports